module.exports = __webpack_public_path__ + "img/consult_list1.aa57ee2f.png";